import React from "react";
import {FormControlLabel, ListItem, ListItemSecondaryAction, Radio} from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {isMobileOnly} from "react-device-detect";
import sv from "../../styles/styles";
import {useDispatch} from "react-redux";
import {zoomIntegrationActionTypes} from "../../_constants/actions/integrations/zoomIntegrationActiontypes";

const ZoomRecordingInstance = (props) => {
    const {recording} = props;
    const rId = recording.id;
    const elemSpacing = "30px"; // used in adding spacing to elements

    const handleChange = (e) => {
        e.stopPropagation();
        props.handleSelectRecording(recording);
    };

	const dispatch = useDispatch();
	const dispatchLinkPreview = () => dispatch({type: zoomIntegrationActionTypes.ZOOM_MEETING_RECORDING_PREVIEW});

    return (
        <ListItem button key={rId} dense >

            {/* Selector */}
            <FormControlLabel
                label={recording.name}
                value={rId}
                control={<Radio style={{marginLeft: elemSpacing}} />}
                onChange={handleChange}
            />

            {/* Secondary Action : External play url*/}
            { !isMobileOnly &&              // hide external link for mobile until internal modal player is used
                <ListItemSecondaryAction style={{paddingRight: elemSpacing}}>
                    <a href={recording.play_url} key={rId}>
                        <FontAwesomeIcon
	                        icon={"external-link-alt"}
	                        style={{color: sv.colors.grey}}
	                        onClick={() => dispatchLinkPreview()}
                        />
                    </a>
                </ListItemSecondaryAction>
            }
        </ListItem>
    );
};

export default ZoomRecordingInstance